import FieldProto from "../../../proto/field-proto"
import FieldConfig from "../../../proto/field-config"

// created for Board fields selector and currently has no other purpose
export default class FieldTaskCover extends FieldProto {

    constructor(config: FieldConfig) {
        super(config)

        this.icon = 'i5-cover'

        this.isSortByAvailable = false
    }
}